import * as __NgCli_locale_1 from "@angular/common/locales/en";
import * as __NgCli_locale_2 from "@angular/common";
__NgCli_locale_2.registerLocaleData(__NgCli_locale_1.default);
import '@omnitracs/walkme-component';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { NotSignedInError } from '@ot/shared/utils';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser()
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .catch(err => {
    if (!(err instanceof NotSignedInError)) {
        console.error(err);
    }
});
